import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const queryKeys = createQueryKeyStore({
    projectAccess: {
        byProjectId: (projectId: string) => [projectId],
        documents: (projectId: string) => ["documents", projectId],
    },
    projects: {
        useCaseId: (useCaseId: string) => [useCaseId],
        all: null,
    },
    documents: {
        all: null,
        byProjectId: (projectId: string) => [projectId],
    },
});
